export default __webpack_public_path__ + "static/media/M.8f6cf2aa.svg";